import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

import APIService from '../../services/APIService';
import GradeResponse from '../../models/responses/GradeResponse';

/**
 * Grade card to display a grade and its detail information.
 *
 * @param grade - a single grade
 */
@Component({
  name: 'GradeCard',
})
export default class GradeCard extends Vue {
  @Prop(Object) private grade: GradeResponse | undefined;

  private isOpen = false;

  get isCoach(): boolean {
    return this.$store.getters.isCoach;
  }

  get formattedDate() {
    if (!this.grade) return;
    return moment(this.grade.date, 'YYYY-MM-DD').format('DD.MM.YYYY');
  }

  /**
   * Open and closes dropdown.
   */
  private toggleCard() {
    this.isOpen = !this.isOpen;
  }

  /**
   * Opens grade edit form.
   */
  private openGradeForm() {
    this.$store.commit('setEditGrade', this.grade);
    this.$store.commit('toggleGradeForm');
  }

  /**
   * Deletes a grade.
   */
  private async deleteGrade(): Promise<void> {
    if (!this.grade) return;
    await APIService.deleteGrade(this.grade.id);
    this.$emit('reload');
  }

  /**
   * Opens the confirmation modal for deleting a grade.
   */
  private openConfirmation() {
    this.$store.commit('openModal', {
      title: this.$t('subjectDetail.gradeCard.delete'),
      text: this.$t('general.confirmation'),
      confirmationCallback: this.deleteGrade,
    });
  }
}
